import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import "./App.css";
import Home from "./components/HomePage/Home";
import AboutUs from "./components/AboutUs";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Menu from "./components/Menu/Menu";
import ContactUs from "./components/ContactUs";
import Gallery from "./components/Gallery";
import Decorations from "./components/Decorations";
import Cakes from "./components/Cakes/Cakes";
import TableMenu from "./components/Menu/TableMenu";
import PartyMenu from "./components/Menu/PartyMenu";
import ParcelMenu from "./components/Menu/ParcelMenu";
import { LocationProvider, useSelectedLocation } from "./context/LocationContext";

function AppContent() {
  const location = useLocation();
  const { location: activeLocation } = useSelectedLocation();

  return (
    <div>
      {/* Don't show Header on cakes route */}
      {!location.pathname.includes("/cakes") && <Header />}
      <div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/about-us"
            element={
              <AboutUs
                des1="Second Home Kitchen & Restaurant is a destination for the food lovers who look for authentic Rajasthani Cuisine and Punjabi foods. Second home Restaurant, serve the finest traditional Indian Cuisine served in traditional style."
                des2="Second Home Kitchen & Restaurant Established in 2017, Out of a passion for amazing food and service. Restaurant is one of the supreme multi cuisines best restaurants, now serving guests in both Mandsaur and Neemuch. Situated at mid in the city, the joint offers"
                des3={`The best in hospitality, ambience, and entertainment and of course food. ${(
                  <br />
                )} Appealing to the eye this multi-cuisine restaurant does stimulate the senses fully.We believe that using the freshest ingredients produces the best results. We are tireless in staying abreast of the latest food trends. And we are obsessed with creating customized menus and culinary masterpieces for our clients. Simply put: we exist to make your vision a reality`}
                des4="Choice of Indian, Rajasthani, Gujrati, Chinese, Continental, South Indian Cuisines Is Available To Satisfy The Taste Buds Of All Discerning Gourmands. We Provide some of the special dishes of Mewar Region like Rajasthani food."
              />
            }
          />
          <Route path="/menu" element={<Menu />} />
          <Route path="/table-menu" element={<TableMenu />} />
          <Route path="/party-menu" element={<PartyMenu />} />
          <Route path="/parcel-menu" element={<ParcelMenu />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/cakes" element={<Cakes />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/decorations" element={<Decorations />} />
        </Routes>
      </div>
      <Footer />
      <a
        href={`https://api.whatsapp.com/send/?phone=${activeLocation.whatsapp}&text=Thank+you+for+contacting+Second+Home+Kitchen+%26+Restaurant%21+Please+let+us+know+how+we+can+help+you.&type=phone_number&app_absent=0`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="fixed bottom-6 right-6 z-[100] w-14 h-14 rounded-full bg-[#25D366] shadow-lg flex items-center justify-center hover:scale-110 transition"
      >
        <FaWhatsapp className="text-white text-3xl" />
      </a>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <LocationProvider>
        <AppContent />
      </LocationProvider>
    </BrowserRouter>
  );
}

export default App;
